document.addEventListener("DOMContentLoaded", function () {

    const form = document.getElementById("bulkEnquiryForm");

    if (!form) return;

    form.addEventListener("submit", async function (e) {

        e.preventDefault();

        const btn = form.querySelector(".bulk-btn");

        btn.disabled = true;
        btn.innerHTML = "Submitting...";

        const formData = new FormData(form);

        try {

            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result.success) {

                form.innerHTML = `
                    <div class="bulk-success">

                        <div class="success-icon">✓</div>

                        <h2>Thank You!</h2>

                        <p>
                            Your bulk enquiry has been submitted successfully.
                        </p>

                        <p>
                            Our team will contact you shortly.
                        </p>

                    </div>
                `;

            } else {

                alert("Something went wrong. Please try again.");

                btn.disabled = false;
                btn.innerHTML = "Submit Bulk Enquiry";

            }

        } catch (error) {

            alert("Network Error.");

            btn.disabled = false;
            btn.innerHTML = "Submit Bulk Enquiry";

        }

    });

});